/**
 * Runtime polyfills for the few ES2022 APIs our dependencies use that still throw on browsers
 * older than the Vite build target (Safari < 15.4, Chrome < 93, Firefox < 92).
 *
 * `Object.hasOwn is not a function` was the only genuine error left in Sentry once the
 * console noise was filtered out (ND-5676). Imported first thing in main.tsx.
 */
if (typeof Object.hasOwn !== 'function') {
  Object.defineProperty(Object, 'hasOwn', {
    value: (object: object, key: PropertyKey): boolean => Object.prototype.hasOwnProperty.call(Object(object), key),
    configurable: true,
    writable: true,
  });
}

export {};
